// @tennis-matches/core/constants/contactsAdmin
// Kanonische Web-Host-Pfade für Verwaltung → Kontakte (früher /verwaltung/spieler).

export const CONTACTS_ADMIN_LIST_PATH = "/verwaltung/kontakte";

/** Legacy-Aliase, die weiterhin als gleiche Route erkannt werden. */
export const CONTACTS_ADMIN_PATH_SEGMENTS = Object.freeze([
  "kontakte",
  "spieler",
  "personen",
  "people",
]);

export function isContactsAdminPathSegment(segment) {
  const s = String(segment ?? "").trim().toLowerCase();
  return CONTACTS_ADMIN_PATH_SEGMENTS.includes(s);
}

/**
 * @param {string} pathname
 * @returns {string} Person/Kontakt-ID oder leer
 */
export function getContactsAdminDetailPersonId(pathname) {
  const segments = String(pathname || "")
    .replace(/^\/+/, "")
    .split("/")
    .filter(Boolean);
  if (String(segments[0] || "") !== "verwaltung") return "";
  if (!isContactsAdminPathSegment(segments[1])) return "";
  return String(segments[2] || "").trim();
}

/**
 * @param {string|number|null|undefined} personId
 * @returns {string}
 */
export function buildContactsAdminDetailPath(personId) {
  const id = String(personId ?? "").trim();
  if (!id) return CONTACTS_ADMIN_LIST_PATH;
  return `${CONTACTS_ADMIN_LIST_PATH}/${encodeURIComponent(id)}`;
}

/**
 * @param {unknown} path
 * @returns {boolean}
 */
export function isContactsAdminDetailReturnPath(path) {
  const s = String(path ?? "").trim();
  if (!s.startsWith("/")) return false;
  if (s.includes("..") || s.includes("//")) return false;
  const pathOnly = s.split("?")[0];
  const seg = pathOnly.replace(/^\/+/, "").split("/").filter(Boolean);
  if (seg.length < 3) return false;
  if (String(seg[0] || "") !== "verwaltung") return false;
  if (!isContactsAdminPathSegment(seg[1])) return false;
  return Boolean(String(seg[2] || "").trim());
}

/**
 * @param {string} path — beginnt mit /
 * @returns {boolean}
 */
export function isContactsAdminListOrDetailPath(path) {
  const pathOnly = String(path || "").split("?")[0].split("#")[0];
  if (!pathOnly.startsWith("/verwaltung/")) return false;
  const seg = pathOnly.replace(/^\/+/, "").split("/").filter(Boolean);
  if (seg.length < 2 || seg.length > 3) return false;
  return isContactsAdminPathSegment(seg[1]);
}

/**
 * Ersetzt Legacy-Segmente spieler/personen/people durch kontakte.
 * @param {string} pathname
 * @returns {string|null} neuer Pfad oder null wenn kein Redirect nötig
 */
export function canonicalizeContactsAdminPathname(pathname) {
  const segments = String(pathname || "")
    .replace(/^\/+/, "")
    .split("/")
    .filter(Boolean);
  if (String(segments[0] || "") !== "verwaltung") return null;
  const sub = String(segments[1] || "").trim().toLowerCase();
  if (sub === "kontakte") return null;
  if (sub !== "spieler" && sub !== "personen" && sub !== "people") return null;
  const tail = segments.slice(2).join("/");
  return `/verwaltung/kontakte${tail ? `/${tail}` : ""}`;
}
